// extracted by mini-css-extract-plugin
export default {"wrapper":"spinner_wrapper__8278f","backdrop":"spinner_backdrop__VIxHH","spinner":"spinner_spinner__mX5BA","loaderAnimation":"spinner_loaderAnimation__7UP2-"};